// Module
var code = "\n    <div class=\"field-wrapper {{if Item.Deleted}} deleted {{/if}}\">\n        {{if Item.Deleted}}\n        <div class=\"delete-field red\">\n            <label><input type=\"checkbox\" class=\"delete-checkbox\">&nbsp;${Resources.removeField}</label>\n        </div>\n        {{/if}}\n        <div class=\"field-container\"></div>\n    </div>\n";
// Exports
var htmlContent = code;
jQuery.templatesHtml['#form-record-field-base'] = htmlContent;
module.exports = "form-record-field-base";